import jwt_decode from 'jwt-decode';

import SignInClass from 'src/model/signIn.model';
import BaseAPIService from 'src/services/base/base-api-service';
import env from 'src/shared/env';

/**
 * This endpoint can receive the next params
 * username: string,
 * password: string
 */

class SignInService extends BaseAPIService<SignInClass> {
  private basicURL: string = env.REACT_APP_BASE_API_URL;
  private endpoint: string = '/accountapp/v1/security/api/auth/login';

  constructor() {
    super(SignInClass);
  }

  public sigIn(username: string = '', password: string = ''): Promise<any> {

    const urlstring = window.location.href; // window.location.href
    const urlstring2 = urlstring.replace("#", 'pars');
    const url = new URL(urlstring2);
    const redirectUrl = url.searchParams.get("redirect");

    return new Promise((resolve, reject) => {
      this.doRequest({
        baseURL: this.basicURL,
        method: 'POST',
        data: {
          username,
          password,
          redirectUrl
        },
        url: this.endpoint
      })
        .then((response: any) => {
          const token: any = jwt_decode(response.data.accessToken);

          const res = this.base.cast<SignInClass>(response.data, this.base);
          if (response.data.isSamsungUser) {
            localStorage.setItem('isSamsungUser', response.data.isSamsungUser);
          }
          console.log('res', response.data.isSamsungUser);
          if (!token.accountId) {
            res.shouldSelectAccount = true;
          } else {
            res.shouldSelectAccount = false;
          }

          localStorage.setItem('redirectUrl', "");
          if(response.data.redirectUrl) {
            localStorage.setItem('redirectUrl', response.data.redirectUrl);
          }

          resolve(res);
        })
        .catch(error => reject(error));
    });
  }

  public switchAccount = (
    accountId: string,
    clientIdentity: string
  ): Promise<any> => {
    return new Promise((resolve, reject) => {
      localStorage.setItem('coming_from_page', 'switchAccount');
      this.doRequest({
        baseURL: this.basicURL,
        method: 'POST',
        data: {
          accountId,
          clientIdentity
        },
        url: `/accountapp/v1/security/api/auth/switch/account`
      })
        .then((response: any) => {
          const res = {
            ...response.data
          };
          const token: any = jwt_decode(response.data.accessToken);
          if (!token.accountId) {
            res.shouldSelectAccount = false;
          } else {
            res.shouldSelectAccount = true;
          }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}

const signInServiceInstance = new SignInService();
Object.freeze(signInServiceInstance);

export default signInServiceInstance;
